module.exports = __webpack_public_path__ + "img/company-culture.b06082d6.png";